import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7466ffec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg",
  style: {"text-align":"center"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { id: "wasm" }, null, -1))
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Collatz Conjecture Calculator", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"color":"#fb8500","font-size":"30px","margin-top":"-5vh"} }, " Using WebAssembly ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"font-weight":"400","line-height":"1.5"} }, [
  /*#__PURE__*/_createTextVNode(" I chose to use WebAssembly to compute the Collatz Conjecture algorithm because it offers near-native performance, allowing for efficient execution of computationally intensive tasks directly in the browser. This enables users to experience rapid calculations without the overhead of JavaScript, enhancing the overall responsiveness of the application. Additionally, WebAssembly's ability to work seamlessly with existing web technologies makes it a powerful tool for building high-performance web applications. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Below is the C code used to generate the .wasm file. ")
], -1))
const _hoisted_7 = { class: "code-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"font-weight":"400","line-height":"1.5"} }, " As well as the WAT representation. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This program is designed to take in a positive integer and run the following algorithm: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " If the integer is even, divide it by two, and start algorithm again "),
  /*#__PURE__*/_createElementVNode("li", null, " If the integer is odd, multiply it by three and add one, and start algorithm again "),
  /*#__PURE__*/_createElementVNode("li", null, " Loop this alorithm until it converges to 1, and count the number of itterations that takes ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In the end, it returns the total number of steps to get to 1.", -1))
const _hoisted_12 = {
  key: 0,
  class: "result"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from "vue";
import code from "raw-loader!../data/wasm.txt";
import wasmCode from "raw-loader!../data/collatzWAT.txt";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "WasmTest",
});

interface WasmExports {
  c: (n: number) => number; // Updated to match the new exported function name
}

// Function to load the WASM module

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const inputNumber = ref<number | null>(null);
const steps = ref<number | null>(null);
const error = ref<string | null>(null);

// Define the import object
const importObject = {
  env: {
    memory: new WebAssembly.Memory({ initial: 1 }),
    log: (arg: number) => console.log(arg),
  },
};

// Define the interface for WASM exports
async function loadWasm() {
  try {
    const response = await fetch("https://mkgz.me/collatz.wasm"); // Update with the correct path
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const bytes = await response.arrayBuffer();
    const results = await WebAssembly.instantiate(bytes, importObject);
    return results.instance.exports as unknown as WasmExports;
  } catch (err) {
    error.value = "Error loading WASM module";
    console.error(err);
    return null;
  }
}

// Function to calculate steps
async function calculateSteps() {
  error.value = null;
  steps.value = null;

  if (
    inputNumber.value === null ||
    isNaN(inputNumber.value) ||
    inputNumber.value < 1
  ) {
    error.value = "Please enter a valid number.";
    return;
  }

  const wasmModule = await loadWasm();
  if (wasmModule) {
    steps.value = wasmModule.c(inputNumber.value); // Call the function named "c"
  }
}

return (_ctx: any,_cache: any) => {
  const _component_highlightjs = _resolveComponent("highlightjs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_highlightjs, {
          class: "code-block",
          language: "c",
          code: _unref(code)
        }, null, 8, ["code"]),
        _hoisted_8,
        _createVNode(_component_highlightjs, {
          class: "code-block",
          language: "asm",
          code: _unref(wasmCode)
        }, null, 8, ["code"])
      ]),
      _hoisted_9,
      _hoisted_10,
      _hoisted_11
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputNumber).value = $event)),
      type: "number",
      placeholder: "Enter a number"
    }, null, 512), [
      [_vModelText, inputNumber.value]
    ]),
    _createElementVNode("button", { onClick: calculateSteps }, "Calculate Steps"),
    (steps.value !== null)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_12, [
          _createTextVNode(" Number of steps to complete = "),
          _createElementVNode("b", null, _toDisplayString(steps.value), 1)
        ]))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    _hoisted_14
  ]))
}
}

})